import React from 'react'
import './Checkout.css'
import CheckoutProduct from './CheckoutProduct';
import Subtotal from './Subtotal'
import { useStateValue } from './StateProvider';

function Checkout() {

    const [{basket}, dispatch] = useStateValue();

    return (
        <div className="checkout">
            <div className="checkout_left">
                 
               <a href="https://www.amazon.in/Complete-Facebook-Advertising-Guide-Entrepreneurial/dp/1701690136"> 
               <img className="checkout__ad" src="https://www.bannersmall.com/wp-content/uploads/2018/02/port-gif72890-00005.gif" alt=""/>
               </a>

                <div>
                    <h2 className="checkout_title">Your Shopping Basket</h2>

                    {basket.map((item) => (
                        <CheckoutProduct 
                        id= {item.id}
                        title= {item.title}
                        image= {item.image}
                        rating= {item.rating} 
                        price= {item.price}
                        />
                    ))}

                </div>

            </div>

            <div className="checkout_right">
                <Subtotal />
            </div>

        </div>
    )
}

export default Checkout 
